const version = "1.8.11";

export default version;
